import React, { useState, useEffect, useCallback } from 'react';

import { useWindowSize } from 'hooks/useWindowSize';
import { contestLanguages } from 'util/appConstants';
import { layouts } from 'components/FreecodePage/FreecodeLayoutConstants';

export const FreecodeContext = React.createContext();

export const FreecodeContextProvider = ({ children }) => {
  const [isCreator, setIsCreator] = useState(false);
  const [submit, setSubmit] = useState(undefined);
  const [layout, setLayout] = useState(layouts.spinner);
  const [exerciseOptions, setExerciseOptions] = useState(undefined);
  const [test, setTest] = useState(undefined);
  const [testImpl, setTestImpl] = useState(undefined);
  const [sponsor, setSponsor] = useState(undefined);
  const [ticket, setTicket] = useState(undefined);
  const [languageData, setActualLanguageData] = useState(undefined);
  const [language, setLanguage] = useState('python');
  const [input, setInput] = useState(undefined);
  const [code, setCode] = useState('');

  const size = useWindowSize();

  const setLanguageData = useCallback((newLanguageData) => {
    for (const key in newLanguageData) {
      newLanguageData[key].icon = contestLanguages.find((data) => data.value === key)?.icon;
    }
    setActualLanguageData(newLanguageData);
  }, []);

  useEffect(() => {
    let tmpLayout = layouts.default;
    if (size?.width && size.width >= 1900 && size.width / size.height > 1.5) {
      tmpLayout = layouts.wide;
    } else if ((size?.width && size.width < 900) || size.height / size.width > 2) {
      tmpLayout = layouts.small;
    }
    if (tmpLayout !== layout) {
      setLayout(tmpLayout);
    }
  }, [size, layout]);

  return (
    <FreecodeContext.Provider
      value={{
        isCreator,
        setIsCreator,
        submit,
        setSubmit,
        layout,
        exerciseOptions,
        setExerciseOptions,
        test,
        setTest,
        testImpl,
        setTestImpl,
        sponsor,
        setSponsor,
        ticket,
        setTicket,
        languageData,
        setLanguageData,
        language,
        setLanguage,
        input,
        setInput,
        code,
        setCode,
      }}
    >
      {children}
    </FreecodeContext.Provider>
  );
};
